export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL || 'support@ltrjlabs.com';
